<div class="card usuario-container">
    <p-toolbar styleClass="mb-4 usuario-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple [disabled]="permissaoService.can('cadastro_de_usuarios_inserir') == false"
                label="Novo" icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>

    </p-toolbar>

    <div class="usuario-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','name','email','empresa','perfil']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Usuários</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 8%">Código</th>
                <th style="width: 18%">Nome</th>
                <th style="width: 20%">E-mail</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 16%">Data do cadastro</th>
                <th class="col-acoes" style="width: 14%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Nome: </span>{{dt.name}}</td>
                <td><span class="p-column-title negrito">E-mail: </span>{{dt.email}}</td>
                <td><span class="p-column-title negrito">Tipo: </span>{{dt.perfil}}</td>
                <td><span class="p-column-title negrito">Data do cadastro: </span>{{dt.created_at | date:
                    'dd/MM/yyyy' }}</td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button *ngIf="dt.tipo != 1" pButton [disabled]="permissaoService.can('cadastro_de_usuarios_editar') == false || enviandoConviteId === dt.id" pRipple
                        icon="pi pi-envelope" class="p-button-rounded p-button-info mr-2"
                        pTooltip="Enviar e-mail de convite" (click)="confirmarEnvioConvite(dt)"></button>
                    <button *ngIf="dt.tipo != 1" pButton [disabled]="permissaoService.can('cadastro_de_usuarios_inserir') == false" pRipple
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" (click)="edit(dt)"></button>
                    <button *ngIf="dt.tipo != 1" pButton [disabled]="permissaoService.can('cadastro_de_usuarios_excluir') == false" pRipple
                        icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        pTooltip="Excluir usuário" (click)="confirmarExclusao(dt)"></button>
                </td>
            </tr>
        </ng-template>

        </p-table>
    </div>
</div>


<p-dialog header="Usuário" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '85vw', '640px': '95vw'}"
    [style]="{width: '55vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="usuario-dialog-body">
        <form [formGroup]="form" class="p-fluid">
            <div class="usuario-dialog-layout">

                <!-- Coluna de campos -->
                <div class="usuario-fields">
                    <div class="field" *ngIf="!isUsuarioExterno">
                        <div class="checkbox-row">
                            <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                            <label class="form-check-label" for="ativo">Ativo</label>
                        </div>
                    </div>

                    <div class="field">
                        <p-floatlabel>
                            <input type="text" id="name" pInputText formControlName="name">
                            <label for="name">Nome</label>
                        </p-floatlabel>
                        <small *ngIf="form.get('name').invalid" class="p-error">Nome é obrigatório.</small>
                    </div>

                    <div class="field">
                        <p-floatlabel>
                            <input type="text" id="email" pInputText formControlName="email">
                            <label for="email">E-mail</label>
                        </p-floatlabel>
                        <small *ngIf="form.get('email').invalid" class="p-error">E-mail é obrigatório.</small>
                    </div>

                    <div class="field">
                        <p-floatlabel>
                            <input type="password" id="password" pInputText formControlName="password">
                            <label for="password">Senha</label>
                        </p-floatlabel>
                    </div>

                    <div class="field" *ngIf="!isUsuarioExterno">
                        <div class="checkbox-row">
                            <input type="checkbox" class="form-check-input" id="usuario_interno" formControlName="usuario_interno">
                            <label class="form-check-label" for="usuario_interno">Usuário interno</label>
                        </div>
                    </div>

                    <div class="field" *ngIf="isUsuarioExterno || form.get('usuario_interno').value == false">
                        <p-floatlabel>
                            <p-multiSelect [options]="dropDownEmpresas" [filter]="true"
                                formControlName="empresa_id" appendTo="body" optionLabel="label">
                            </p-multiSelect>
                            <label for="empresa_id">Empresa</label>
                        </p-floatlabel>
                        <small *ngIf="!hasEmpresaSelecionada()" class="p-error">Empresa é obrigatório.</small>
                    </div>

                    <div class="field">
                        <p-floatlabel>
                            <p-dropdown inputId="grupo_usuario_id" appendTo="body" [filter]="true" [options]="dropDownGrupos"
                                optionLabel="label" optionValue="value" formControlName="grupo_usuario_id">
                            </p-dropdown>
                            <label for="grupo_usuario_id">Perfil</label>
                        </p-floatlabel>
                        <small *ngIf="isGrupoUsuarioNaoSelecionado()" class="p-error">Perfil é obrigatório.</small>
                    </div>
                </div>

                <!-- Coluna da foto -->
                <div class="usuario-avatar-section">
                    <span class="avatar-label">Foto do usuário</span>
                    <div class="avatar-container">
                        <div class="avatar-wrapper">
                            <img
                                [src]="imagePreviewUrl || form.get('url_imagem_usuario').value || defaultUserImage"
                                alt="Foto do usuário"
                                class="avatar-img"
                                (error)="onPreviewImageError($event)">
                            <label for="image-upload" class="avatar-overlay" title="Alterar foto">
                                <i class="pi pi-camera"></i>
                            </label>
                            <input id="image-upload" type="file" accept="image/*"
                                   (change)="onImageUpload($event)" style="display: none;">
                        </div>
                        <button
                            *ngIf="imagePreviewUrl || form.get('url_imagem_usuario').value"
                            type="button"
                            class="avatar-clear-btn"
                            title="Remover foto"
                            (click)="clearImage()">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                    <span class="avatar-hint">
                        {{ imagePreviewUrl || form.get('url_imagem_usuario').value ? 'Clique para alterar' : 'Clique para adicionar' }}
                    </span>
                </div>

            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false"
            [disabled]="form.invalid || (form.get('usuario_interno').value == false && !hasEmpresaSelecionada()) || (form.get('id').value == null && (form.get('password').value == null || form.get('password').value == '')) || isGrupoUsuarioNaoSelecionado()"
            pButton pRipple type="button" icon="pi pi-check" (click)="save()" label="Salvar"
            class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
